import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { TPVServices } from "../services";
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../../configuration/services';
import { TpvTicketSelectedCashPage } from './tpv-ticket-selected/tpv-ticket-selected-cash/tpv-ticket-selected-cash';
import { PopupErrorsPage } from '../../components/popups/popup-errors/popup-errors';
import { TranslateService } from '@ngx-translate/core';
import { TpvLoaderPage } from '../tpv-loader/tpv-loader';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket',
  templateUrl: 'tpv-ticket.html',
})
export class TpvTicketPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    private modalCtrl: ModalController,
    public translate: TranslateService) {

    this.globals.GAtrackView('TPV', 'TPV - Ticket', this.globals.restaurant.email, 'View', 'View TPV ticket', 'TPV', '');

    if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].state == 'open') {
      this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter = this.globals.waiter;
      this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter_uid = this.globals.waiter_uid;
    }
  }

  ionViewWillEnter() {
    if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].type != 'bar') {
      this.getIfRoom();
    } else {//check si bar tiene caja
      this.checkRoomHasCash();
    }
  }

  ionViewDidLoad() {
    this.tpvServices.autoScrollEnterElements();
  }

  async getIfRoom() {
    if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room == undefined) {
      //get room
      var room = await this.configurationServices.getRoom(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].uid_room);
      //update
      this.configurationServices.afs.collection('tables').doc(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID).update({
        room: room.name,
      });
    }
    //checkRoomHasCash
    this.checkRoomHasCash();
  }

  checkRoomHasCash() {
    var _table_nocash = this.tpvServices.cashs_array.find(e => e.UID === this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid);
    if (!_table_nocash) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, {
        title: this.translate.instant('general-cajas'),
        origin: 'tpv-error-caja',
        msg: this.translate.instant('tpv-ticket-esta-mesa-tiene-caja-no-existe')
      });
      profileModal.onDidDismiss(data => {
        if (data) {
          if (data.open_change_cash) {
            this.navCtrl.push(TpvTicketSelectedCashPage);
          }

          if (data.close) {
            this.navCtrl.push(TpvLoaderPage);
          }
        }

      });
      profileModal.present();
    } else if (!_table_nocash._active) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, {
        title: this.translate.instant('general-cajas'),
        origin: 'tpv-error-caja',
        msg: this.translate.instant('instant-caja-bloqueda-version')
      },
        { enableBackdropDismiss: false }
      );
      profileModal.onDidDismiss(data => {
        if (data) {
          if (data.open_change_cash) {
            this.navCtrl.push(TpvTicketSelectedCashPage);
          }
          if (data.close) {
            this.navCtrl.push(TpvLoaderPage);
          }
        }

      });
      profileModal.present();
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket.ts